import React from 'react';
import { Typography } from "@mui/material";

function getCategoryTitle(row) {
    return row.title_en || row.title_ru || row.title_hy || '—';
}

export const CategoryColumns = () => [
    {
        id: "order",
        label: "Order",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {row.order ?? '—'}
            </Typography>
        )
    },
    {
        id: "title",
        label: "Title",
        render: (value, row) => (
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {getCategoryTitle(row)}
            </Typography>
        )
    },
    {
        id: "title_ru",
        label: "Title (RU)",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {row.title_ru || '—'}
            </Typography>
        )
    },
    {
        id: "title_hy",
        label: "Title (HY)",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {row.title_hy || '—'}
            </Typography>
        )
    },
    {
        id: "parent",
        label: "Parent",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {row.parent ? (row.parent.title_en || row.parent.title_ru || row.parent.title_hy || row.parent.id) : '—'}
            </Typography>
        )
    },
];
